import currencyLib from "currency.js";
import { LatLng } from "use-places-autocomplete";
import { ROUNDING_ENUM } from "../../enums";

export const roundNumber = (inp: number) => {
  try {
    return Number(inp.toFixed(2));
  } catch (e) {
    alert("Please try again later");

    return null as unknown as number;
  }
};

export const divideWithRoundingOrCurrency = (
  hasRoundingMethodAndLevel: boolean,
  number1: number,
  number2: number
) => {
  let total;
  if (hasRoundingMethodAndLevel) {
    total = number1 / number2;
  } else {
    total = currencyLib(number1).divide(number2).value;
  }

  return total;
};

export const multiplyWithRoundingOrCurrency = (
  hasRoundingMethodAndLevel: boolean,
  number1: number,
  number2: number
) => {
  let total;
  if (hasRoundingMethodAndLevel) {
    total = number1 * number2;
  } else {
    total = currencyLib(number1).multiply(number2).value;
  }

  return total;
};

export const subtractWithRoundingOrCurrency = (
  hasRoundingMethodAndLevel: boolean,
  number1: number,
  number2: number
) => {
  let total;
  if (hasRoundingMethodAndLevel) {
    total = number1 - number2;
  } else {
    total = currencyLib(number1).subtract(number2).value;
  }

  return total;
};

export const addWithRoundingOrCurrency = (
  hasRoundingMethodAndLevel: boolean,
  number1: number,
  number2: number
) => {
  let total;
  if (hasRoundingMethodAndLevel) {
    total = number1 + number2;
  } else {
    total = currencyLib(number1).add(number2).value;
  }

  return total;
};

export const removePercentageValue = (
  percentage: number,
  value: number,
  hasRoundingMethodAndLevel: boolean
) => {
  // return currencyLib(1 - currencyLib(percentage).divide(100).value).multiply(
  //   value
  // ).value;
  const percentageDivided = divideWithRoundingOrCurrency(
    hasRoundingMethodAndLevel,
    percentage,
    100
  );
  const subtractFromPercentage = subtractWithRoundingOrCurrency(
    hasRoundingMethodAndLevel,
    1,
    percentageDivided
  );

  return multiplyWithRoundingOrCurrency(
    hasRoundingMethodAndLevel,
    subtractFromPercentage,
    value
  );
};

export function pointInPolygon(point: LatLng, polygon: LatLng[]) {
  const x = point.lng;
  const y = point.lat;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].lng;
    const yi = polygon[i].lat;
    const xj = polygon[j].lng;
    const yj = polygon[j].lat;

    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

    if (intersect) {
      inside = !inside;
    }
  }

  return inside;
}

export const toFixedNum = (number: number, toFixedApprox: number) => {
  return String(
    Math.trunc(number * Math.pow(10, toFixedApprox)) /
      Math.pow(10, toFixedApprox)
  );
};

export const calculateNumberRounding = (
  number: number,
  roundingMethod: string,
  roundingLevel: number,
  toFixedApprox: number = 2
) => {
  let roundingNumber;
  switch (roundingMethod) {
    case ROUNDING_ENUM.AVERAGE:
      roundingNumber = (
        Math.round(number * roundingLevel) / roundingLevel
      ).toFixed(toFixedApprox);
      break;

    case ROUNDING_ENUM.UP:
      roundingNumber = (
        Math.ceil(number * roundingLevel) / roundingLevel
      ).toFixed(toFixedApprox);
      break;

    case ROUNDING_ENUM.DOWN:
      roundingNumber = (
        Math.floor(number * roundingLevel) / roundingLevel
      ).toFixed(toFixedApprox);
      break;

    case ROUNDING_ENUM.NONE:
    default:
      roundingNumber = toFixedNum(number, toFixedApprox);
      break;
  }

  return parseFloat(roundingNumber);
};

export const levenshteinDistance = (a: string, b: string): number => {
  const matrix: number[][] = [];

  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }

  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }

  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }

  return matrix[b.length][a.length];
};

export function isNumber(value: any): boolean {
  return typeof value === "number" && isFinite(value);
}
